import { saveAs } from 'file-saver';

export function sanatizedSaveAs(blob: any, name?: String, opts?: any) {
  let filename: String;
  if (name) {
    filename = name;
  } else {
    filename = blob.name;
  }
  // In Javascript apparently \w doesn't contain umlauts, so we have to specify manually.
  filename = filename.replace(/[^\w0-9.\-_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]{1,}/gi, '-');
  // replace all but the last dot
  const lastDotIndex = filename.lastIndexOf('.');
  while (filename.indexOf('.') !== lastDotIndex) {
    filename = filename.replace('.', '-');
  }
  return saveAs(blob, filename, opts);
}
